import { render, staticRenderFns } from "./NewspaperLayout.vue?vue&type=template&id=d0d220ac"
import script from "./NewspaperLayout.vue?vue&type=script&lang=js"
export * from "./NewspaperLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports